import * as t from 'io-ts';

export const AccountLinkDynamicType = t.interface({
    emailAddress: t.string
});

export type AccountLink = t.TypeOf<typeof AccountLinkDynamicType>;
